import {BankAccountPendingMovements} from '../services/resources';

const state = {};

const mutations = {};

const actions = {
    getBankAccountPendingMovements(context, pagination) {
        return BankAccountPendingMovements.getBankAccountPendingMovements(pagination).then((response) => {
            return response.data;
        });
    },
};

const module = {
    state,
    mutations,
    actions
};

export default module;
